<template>
    <div>
        <v-card>
            <v-card-title class="pt-0 pb-2 d-flex">
                <v-select style="width: 40%;" color="deep-purple accent-4" class="mx-2 flex-grow-0" no-data-text="Нет данных" :items="filter_order_modes" name="order_mode" v-model="filter_order_mode" label="По типу" hide-details> </v-select>

                <v-spacer></v-spacer>

                <v-text-field style="width: 40%;" color="deep-purple accent-4" v-model="search" append-icon="mdi-magnify" :label="$t('common.search')" outlined dense rounded single-line hide-details></v-text-field>

                <v-spacer></v-spacer>

                <v-btn icon @click="dataUpdate">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    style="max-height: 70vh; min-height: 70vh; cursor: pointer;"
                    :headers="headers"
                    :items="filteredOrders"
                    :search="search"
                    :single-expand="singleExpand"
                    show-expand
                    item-key="id"
                    fixed-header
                    class="elevation-0 overflow-y-auto"
                    no-data-text="Нет активных заказов"
                    no-results-text="Нет такого заказа, попробуйте изменить запрос"
                    checkbox-color="deep-purple accent-4"
                    hide-default-footer
                    :footer-props="{
                        itemsPerPageOptions: [-1],
                    }"
                    @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <div class="d-flex">
                            <v-menu open-delay="750" open-on-hover :close-on-content-click="false" bottom offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip small v-bind="attrs" v-on="on" :color="Array.isArray(item.orders) ? orderStatusColorHtml1(item.status, true) : orderStatusColorHtml1(item.status)" text-color="white">
                                        <v-icon size="small" class="mr-1">{{ orderStatusIcon1(item.status) }}</v-icon>
                                        {{ Array.isArray(item.orders) ? `${item.name.split('/')[0]} +${(item.orders.length - 1)}` : item.name }}
                                    </v-chip>   
                                </template>
                                <v-card class="mx-auto" min-width="120" max-width="400" outlined>
                                    <div class="order-card" v-html="Array.isArray(item.orders) ? multiOrderFullText1(item.point, item) : orderFullText1(item.point, item)"></div>
                                </v-card>
                            </v-menu>
                        </div>
                    </template>

                    <template v-slot:[`item.createdAt`]="{ item }"> {{ getOrderMode(item, true) }} {{ timeToString(item.createdAt) }} </template>

                    <template v-slot:[`item.dateReady`]="{ item }">
                        {{ timeToString(item.dateReady) }}
                    </template>

                    <template v-slot:[`item.dateDelivery`]="{ item }">
                        {{ timeToString(item.dateDelivery) }}
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <order-row-action :order="item" :couriers="couriers" @update="dataUpdate"></order-row-action>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
        </v-card>
    </div>
</template>

<script>
    import config from '../../config'
    import DateTime from '../../mixins/DateTime.js'
    import Status from '../../mixins/Status.js'
    import Orders from '../../mixins/Orders.js'
    import OrderRowAction from './row_action/OrderRowAction.vue'

    export default {
        data() {
            return {
                e1: 1,
                config,
                search: '',
                singleExpand: false,
                headers: [
                    {
                        text: 'Название',
                        value: 'name',
                        sortable: false,
                    },
                    {
                        text: 'Готов',
                        value: 'createdAt',
                        sortable: true,
                    },
                    {
                        text: 'Забрать',
                        value: 'dateReady',
                        sortable: true,
                    },
                    {
                        text: 'Доставить',
                        value: 'dateDelivery',
                        sortable: true,
                    },
                    {
                        text: 'Действие',
                        value: 'data-table-expand',
                        sortable: false,
                    },
                ],
                filter_order_mode: 0,
                filter_order_modes: [
                    {
                        text: '< Все >',
                        value: 0,
                    },
                    {
                        text: this.getOrderModeString(true),
                        value: 1,
                    },
                    {
                        text: this.getOrderModeString(false),
                        value: 2,
                    },
                ],
                currentItem: {},
            }
        },
        props: {
            couriers: {
                type: Array,
                default: null,
            },
            orders: {
                type: Array,
                default: null,
            },
            // multiOrders: {
            //     type: Array,
            //     default: null,
            // },
        },
        components: {
            OrderRowAction,
        },
        mixins: [DateTime, Orders, Status],
        computed: {
            // filteredOrders() {
            //     return this.orders.filter(o => (this.filter_order_mode ? o.mode == this.filter_order_modes[this.filter_order_mode].text : true))
            // },
            filteredOrders() {
                const allOrders = this.orders
                // const allOrders = [...this.orders, ...this.multiOrders]

                return allOrders.filter(order => {
                    order.name = Array.isArray(order.orders) ? order.orders.map(e => this.getOrderName(e)).join(' / ') : this.getOrderName(order)
                    
                    if (this.filter_order_mode === 2) {
                        return Array.isArray(order.orders) ? !order.orders[0].isNearest : !order.isNearest
                    } else if (this.filter_order_mode === 1) {
                        return Array.isArray(order.orders) ? order.orders[0].isNearest : order.isNearest
                    }

                    return true
                })
            },
        },
        methods: {
            dataUpdate() {
                this.$emit('update')
            },
        },
        mounted() {
            console.log('this.orders', this.orders)
            // console.log('this.multiOrders', this.multiOrders)
        },
    }
</script>
